import Service, { ApiService } from '@/api/service'
import { Router, RoutingData, RouteParams } from 'symfony-ts-router'
import routes from '@/../fos_js_routes.json'

const NAME_PREFIX = 'front_v1_'

export default abstract class BaseService {
    protected api: ApiService;
    private router: Router;

    constructor () {
        this.api = new Service()
        this.router = new Router()
        this.router.setRoutingData((routes as unknown) as RoutingData)
    }

    protected getUrl (name: string, params: RouteParams = {}): string {
        return this.router.generate(NAME_PREFIX + name, params)
    }
}
